<div class="container-fluid" *ngIf="!countryPlaceFlag">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;width:100%">
      <h5 style="float:left;"><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
    </div>
  </div>
  <hr>
  <div class="row">

    <div class="col-md-12">

      <table id="cTypes" border="1" class="table tbl-stl">

        <thead class="thead-inverse tbl-hd-stl hgt-btn">
          <tr style="vertical-align:middle;" class="hgt-btn">
            <th class="bfr-end-col">
              Code
              <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(1)"></i>
            </th>
            <th style="vertical-align:middle;margin:0px;">
              Description
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
                (click)="utility.onSort(2)"></i>
            </th>
            <th style="vertical-align:middle;" class="bfr-end-col">
              ISO alpha-2
            </th>
            <th style="vertical-align:middle;" class="bfr-end-col">
              Dial Code
            </th>
            <th style="vertical-align:middle;" class="bfr-end-col">
              Active ?
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
                (click)="utility.onSort(3)"></i>
            </th>
            <th style="vertical-align:middle;" class="bfr-end-col">
              Sort Order
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
                (click)="utility.onSort(5)"></i>
            </th>
            <th style="vertical-align:middle;" class="bfr-end-col">
              Group
              <i style="vertical-align:middle;" class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
                (click)="utility.onSort(4)"></i>
            </th>
            <th style="vertical-align:middle;" class="bfr-end-col">Display ?</th>

            <!-- <th class="btn-show hgt-btn">Place</th> -->
            <th style="vertical-align:middle;">Place</th>
          </tr>
        </thead>
        <tr style="height: 10px !important;"
          *ngFor="let list of countries  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">

          <td class="bfr-end-col">{{list.code}}</td>
          <td class="bfr-end-col">{{list.desc}}</td>
          <td class="bfr-end-col">{{list.iso_alpha2}}</td>
          <td class="bfr-end-col">{{list.dial_code}}</td>
          <td class="bfr-end-col">{{list.is_active}}</td>
          <td class="bfr-end-col" align="center">{{list.sort_order}}</td>
          <td class="bfr-end-col" align="center">{{list.group_code}}</td>
          <td class="bfr-end-col">{{utility.showDisplayIndicator(list.display_index)}}</td>
          <td align="center" class="bfr-end-col end-col">
            <i class="fa fa-map-marker map-icon" style="font-size: 2em;" title="click here to view places"
              (click)="loadCountryDetails(list)"></i>
          </td>
        </tr>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="countries.length > 4" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">

                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id" style="">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="showNum" style="">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = $event"
                    style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>

          </tr>
          <tr *ngIf="countries.length==0">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No Countries found.</span>
            </td>
          </tr>
        </tfoot>
      </table>
      <div class="clear-fix"></div>
    </div>
  </div>
</div>
<!--
  <div class="col-md-12" *ngIf="countryPlaceFlag">
    <app-manage-country-places [list]="selectCountry"></app-manage-country-places>
  </div>
-->